import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_ZARANDEO } from '../../../../config/tables'

export default function DetalleZarandeoView () {
  return <MuiTable id={TABLA_DETALLE_ZARANDEO} />
}
